import { CapoPlugin } from "E:/W2/VM/VM.Cms/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];